import axios from "axios";
import { useEffect, useState } from "react";
import AdCreative from "../AdCreative";

function DevStatsTopCampaignsItem({
    campaign_id,
    impressions_count,
}) {
    const [campaign, setCampaign] = useState(null);

    function getCampaign() {
        axios.get(
            process.env.REACT_APP_API_HOST + `/campaigns/${campaign_id}/`,
            {},
        ).then(
            (response) => {
                setCampaign(response.data);
            }
        ).catch(
            (error) => {
                // unable to load the campaign
                // TODO: handle this properly on reporting.
            }
        )
    }

    useEffect(
        () => {
            getCampaign();
        },
        [],
    )
    if (!campaign) {
        return (
            <div>
                Loading...
            </div>
        );
    }

    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                marginRight: '2em',
                marginBottom: '2em',
                width: '25em',
            }}>
            <div style={{
                width: '10em',
                height: '8em',
                display: 'flex',
                alignItems: 'center',
                backgroundColor: 'black',
            }}>
                <AdCreative
                    creativeURL={campaign.creative_url}
                    creativeExt={campaign.creative_ext}
                    height='100%'
                    width='100%'
                    objectFit='contain'
                    shouldAutoPlay={false}
                    isMuted={true}
                />
            </div>
            <div style={{ marginLeft: '1em', width: '10em' }}>
                <h3
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}>
                    {campaign.title}
                </h3>
                <div>
                    {impressions_count ?? 0} impressions
                </div>
            </div>
        </div>
    );
}

export default DevStatsTopCampaignsItem;